export default (url, qsParams) => {
  const buildQueryString = (params) => Object.entries(params).map((d) => `${d[0]}=${d[1]}`).join(`&`)

  return new Promise((resolve, reject) => {
    const qs = qsParams ? `?${buildQueryString(qsParams)}` : ``
    const xhr = new XMLHttpRequest()
    xhr.open(`GET`, `${url}${qs}`)

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 400) {
        resolve(JSON.parse(xhr.responseText));
      } else {
        resolve(xhr.responseText);
      }
    }
    xhr.onerror = () => reject(xhr.statusText)
    xhr.send()
  });
};
